<template>
  <div class="home-wrapper-dark">
    <slot></slot>
  </div>
</template>
<script></script>
<style lang="scss">
.home-wrapper-dark {
  background-color: #081b25;
  border-radius: 12px;
  padding-top: 20px;
  padding-bottom: 20px;
  max-width: var(--main-container-max-width);
  margin: 0 auto;

  @media screen and (max-width: 479px) {
    max-width: 95%;
    width: 100%;
  }
}
</style>
